import Api from "./base/api-base";

export default class WorkerDailyReportApi {
  
  list() {
    return Api.get({
      endpoint: Api.endpoint.worker_daily_report
    });
  }

  info (date, id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.worker_daily_report, id: date},
        {endpoint: Api.endpoint.user, id: id}
      ]
    });
  }

  store (params) {
    return Api.post({
      endpoint: Api.endpoint.worker_daily_report,
      params: params
    });
  }

  update (date, id, params) {
    return Api.link.post({
      links: [
        {endpoint: Api.endpoint.worker_daily_report, id: date},
        {endpoint: Api.endpoint.user, id: id}
      ],
      params: params
    });
  }

  delete (date) {
    return Api.delete({
      endpoint: Api.endpoint.worker_daily_report,
      id: date
    });
  }
}